import React, { Fragment } from 'react';

const DecorativeBorder = ({ segmentNr }) => {
  const segments = new Array(segmentNr - 1).fill(null);
  return (
    <div className="mt-[1px] w-full h-[2px] flex flex-row items-stretch leading-[0px]">
      {segments.map((segment, index) => (
        <Fragment key={index}>
          <div className="bg-black flex-1 leading-[0px] h-[2px] p-0 m-0" />
          <div className="w-[2px] h-[2px] leading-[0px] p-0 m-0" />
        </Fragment>
      ))}
      <div className="bg-black flex-1 leading-[0px] h-[2px] p-0 m-0" />
    </div>
  );
};

export default DecorativeBorder;
